export default function Sidebar(store) {
    this.store = store;

    this.setParams = function(params) {
        this.store.dispatch('sidebar/sidebarParams', params);
    };

    this.setComponent = function(component) {
        this.store.dispatch('sidebar/sidebarComponent', component);
    };

    this.show = function(component) {
        if(component)
            this.setComponent(component);

        this.store.dispatch('sidebar/sidebar', true);
    };

    this.hide = function() {
        this.store.dispatch('sidebar/sidebar', false);
    };
}
